import { $Shape } from "utility-types";
import type {
	CheckoutData,
	CheckoutHeader,
	CheckoutNonFsdGroupHeader,
	ClickAndCollectGroupHeader,
	FsdGroupHeader,
} from "./CheckoutData";
export function findFirstFsdGroupHeader(checkout: CheckoutData) {
	return Object.values(checkout.groupHeaders).find(
		(groupHeader) => !!groupHeader && groupHeader.fulfillmentType === "FSD",
	);
}
export function findAllFsdGroupHeaders(checkout: CheckoutData) {
	return Object.values(checkout.groupHeaders).filter(
		(groupHeader): groupHeader is FsdGroupHeader => groupHeader?.fulfillmentType === "FSD",
	);
}
export function findAllNonFsdGroupHeaders(checkout: CheckoutData) {
	return Object.values(checkout.groupHeaders).filter(
		(groupHeader): groupHeader is CheckoutNonFsdGroupHeader => groupHeader?.fulfillmentType !== "FSD",
	);
}
export function findAllClickAndCollectGroupHeaders(checkout: CheckoutData) {
	return Object.values(checkout.groupHeaders).filter(
		(groupHeader): groupHeader is ClickAndCollectGroupHeader =>
			groupHeader?.fulfillmentType === "CLICK_AND_COLLECT",
	);
}
export function updateHeader(checkout: CheckoutData, updatedWith: $Shape<CheckoutHeader>) {
	const header = checkout.header;

	if (header) {
		Object.assign(header, updatedWith);
	}
}
